<template>
  <div class="json-editor">
    <v-btn @click="open" block color="primary">JSON Editor</v-btn>
    <v-dialog fullscreen v-model="openModal">
      <v-card class="d-flex flex-column">
        <v-toolbar class="flex-grow-0" dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>JSON Editor (ADMIN ONLY)</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="flex-grow-1 editor-ctn pa-5">
          <vue-json-editor class="fullscreen" v-model="json" mode="code" @change="onJsonChange" :expandedOnStart="true"></vue-json-editor>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import vueJsonEditor from 'vue-json-editor'
import { mapGetters } from 'vuex'

export default {
  name: 'JSONEditor',
  components: {
    'vue-json-editor': vueJsonEditor
  },
  computed: mapGetters(['stcConfig']),
  data () {
    return {
      json: {},
      openModal: false
    }
  },
  methods: {
    open () {
      this.json = {
        ...this.stcConfig
      }

      this.openModal = true
    },

    close () {
      this.openModal = false
    },

    onJsonChange () {

    },

    save () {
      this.$store.dispatch('updateStcConfig', { config: this.$route.params.id, json: this.json })
      this.openModal = false
    }
  }
}

</script>

<style lang="sass" scoped>

.editor-ctn
  height: 100%

.fullscreen
  height: 100%
  ::v-deep .jsoneditor-vue
    height: 1000px

</style>
